export const BETA_SOURCE_OPTIONS = [
  "Brianna Beta Outreach",
  "Facebook",
  "LinkedIn",
  "Email",
  "Friend Referral",
  "Other"
];

export const BETA_ACCESS_DAYS = 7;

export const BETA_HEADLINE = "Try Ahavibes Free as a Beta User";

export const BETA_INTRO =
  "Ahavibes is a guided reflection tool that helps people slow down emotional reactions, reduce mental overload, and think through difficult moments before they respond.";

export const BETA_AUDIENCE =
  "We are opening early beta access for providers, business owners, coaches, and high-performing individuals who want a better way to process thoughts, reactions, and decisions.";

export const BETA_ACCESS_NOTE = `Beta testers get full member access free for ${BETA_ACCESS_DAYS} days — unlimited insights, mental patterns, and full history — so you can test Ahavibes and share honest feedback.`;

export const BETA_CONSENT_TEXT =
  "I agree to receive beta access details by email and understand Ahavibes may follow up about my experience.";
